"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _icons = require("./icons");

var _themes = require("../../themes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = {
  "icon": "icon__icon___9dbQ1"
};

var Icon = function Icon(props) {
  var glyph = props.glyph,
      className = props.className,
      width = props.width,
      height = props.height,
      compileWithTheme = props.compileWithTheme;
  var _ICONS$glyph = _icons.ICONS[glyph],
      viewBoxWidth = _ICONS$glyph.viewBoxWidth,
      viewBoxHeight = _ICONS$glyph.viewBoxHeight,
      paths = _ICONS$glyph.paths;
  return React.createElement("svg", {
    width: "".concat(width || _constants.DEFAULT_VIEWBOX_WIDTH, "px"),
    height: "".concat(height || _constants.DEFAULT_VIEWBOX_HEIGHT, "px"),
    className: compileWithTheme((0, _classnames["default"])(styles.icon, className)),
    viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight)
  }, paths.map(function (path, key) {
    return (// eslint-disable-next-line react/no-array-index-key
      React.createElement("path", {
        key: key,
        d: path
      })
    );
  }));
};

exports.Icon = Icon;

var _default = (0, _themes.withTheme)(Icon);

exports["default"] = _default;